import React from 'react';

import {sidebarAds1, sidebarAds2} from '../../config/config';
import FloatingActionButtons from "./FloatingActionButtons";
import usePathNameChangeScrollToTop from "../../utils/usePathNameChangeScrollToTop";

const DefaultSideContent = () => {
	return (
		<div className="side-container">
			<a href="#" className="block mb-4">
				<img src={sidebarAds1} alt="Sidebar ADS" className="w-full h-auto rounded-lg"/>
			</a>

			<a href="#" className="block mb-4">
				<img src={sidebarAds2} alt="Sidebar ADS" className="w-full h-auto rounded-lg"/>
			</a>
		</div>
	)
}

const Body = ({mainContent, sidebarContent = null, sidenavContent = null, heroContent = null, heroContentBottom = null}) => {
	usePathNameChangeScrollToTop();

	return (
		<div className="body-container mt-2">
			<div className="main-container h-full w-auto md:mx-4">
				{heroContent && (
					<div className="hero-section hero-section-top w-full">
						{heroContent}
					</div>
				)}

				<div className="h-full w-full flex flex-col lg:flex-row lg:min-h-screen">
					{(sidenavContent) && (
						<div className="sidenav w-full h-auto px-2 mb-4 md:p-4 md:pr-0 lg:mb-0 lg:w-[280px] lg:flex-grow-0 lg:flex-shrink-0">
							<div className="sticky top-4">
								{sidenavContent === 'default'
									? <DefaultSideContent />
									: (
										<div className="side-container">
											{sidenavContent}
										</div>
									)
								}
							</div>
						</div>
					)}

					<div className="main-content w-full flex-grow py-4 px-2 pb-0 min-w-0 md:px-4">
						{mainContent}
					</div>

					{(sidebarContent) && (
						<div className="sidebar h-auto px-2 md:p-4 md:pl-0 lg:w-[280px] lg:flex-grow-0 lg:flex-shrink-0">
							<div className="sticky top-4">
								{sidebarContent === 'default'
									? <DefaultSideContent />
									: (
										<div className="side-container">
											{sidebarContent}
										</div>
									)
								}
							</div>
						</div>
					)}
				</div>

				{heroContentBottom && (
					<div className="hero-section hero-section-bottom w-full">
						{heroContentBottom}
					</div>
				)}
			</div>

			<FloatingActionButtons />
		</div>
	);
};

export default Body;